module.exports = __webpack_public_path__ + "img/mail.9e5019d9.svg";